import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { Candidates } from '../../models/candidates.model';
import { UsersService } from '../../services/users.service';
import { FunctionsService } from '../../services/functions.service';
import { HttpService } from '../../services/http.service';
import { Trainings } from '../../models/trainings.model';
import { Professions } from 'src/app/models/professions.model';
import { CandidatesProfiles } from '../../models/candidatesProfiles.model';
import { CandidatesExperiences } from 'src/app/models/candidatesExperiences.model';
import { AreaActivities } from '../../models/areaActivities.model';
import { CandidatesTrainings } from '../../models/candidatesTrainings.model';
import { CandidatesLanguages } from '../../models/candidatesLanguages.model';
import { Languages } from 'src/app/models/languages.model';
import { CandidatesSkills } from '../../models/candidatesSkills.model';
import { Skills } from '../../models/skills.model';
import { CandidatesCertificates } from 'src/app/models/candidatesCertificates.model';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-candidat-account',
  templateUrl: './candidat-account.component.html',
  styleUrls: ['./candidat-account.component.scss']
})
export class CandidatAccountComponent implements OnInit {


  personalInfoIsLoading: boolean = false;
  profileIsLoading: boolean = false;
  experienceIsLoading: boolean = false;
  trainingIsLoading: boolean = false;
  languageIsLoading: boolean = false;
  skillIsLoading: boolean = false;
  certificatIsLoading: boolean = false;
  personalInfoForm: FormGroup = new FormGroup({});
  profilesForm: FormGroup = new FormGroup({});
  experiencesForm: FormGroup = new FormGroup({});
  trainingsForm: FormGroup = new FormGroup({});
  languagesForm: FormGroup = new FormGroup({});
  skillsForm: FormGroup = new FormGroup({});
  certificatsForm: FormGroup = new FormGroup({});
  candidates: Candidates = new Candidates([]);
  candidatesProfiles: CandidatesProfiles = new CandidatesProfiles({});
  candidatesExperiences: CandidatesExperiences = new CandidatesExperiences({});
  candidatesTrainings: CandidatesTrainings = new CandidatesTrainings({});
  candidatesLanguages: CandidatesLanguages = new CandidatesLanguages({});
  candidatesSkills: CandidatesSkills = new CandidatesSkills({});
  candidatesCertificates: CandidatesCertificates = new CandidatesCertificates({});
  tempWorkerValue: any;
  driverLicenceValue: any;
  passportValue: any;
  experienceProValue: any
  cvValue: any;
  cvFile: any;
  cvPath: any;
  idcardValue: any;
  idcardFile: any;
  idCard: any;
  countryData: any;
  countryList: any[] = [];
  cityList: any[] = [];
  trainingList: Trainings[] = [];
  professionList: Professions[] = [];
  areaActivityList: AreaActivities[] = [];
  attestationFile: any = null;
  experienceList: CandidatesExperiences[] = [];
  languageList: Languages[] = [];
  skillList: Skills[] = [];
  diplomaFile: any = null;
  certificatFile: any = null;
  candidateProfileList: CandidatesProfiles[] = [];
  candidateTrainingList: CandidatesTrainings[] = [];
  candidateLanguageList: CandidatesLanguages[] = [];
  candidateSkillList: CandidatesSkills[] = [];
  candidateCertificateList: CandidatesCertificates[] = [];
  dateObj = new Date();
  currentMonth = (this.dateObj.getUTCMonth() + 1 < 10) ? '0' + (this.dateObj.getUTCMonth() + 1) : this.dateObj.getUTCMonth() + 1;
  currentYear = this.dateObj.getUTCFullYear();
  totalFillingRate = 0;
  personalInfoRate = 0;
  profileRate = 0;
  experienceRate = 0;
  trainingRate = 0;
  languageRate = 0;
  skillRate = 0;
  showBtnToGoApplyJob = false;
  jobIDToApply: any;
  step: any = 1;
  // submenu: any;
  // submenuList: any = ['infos', 'training', 'experience', 'language', 'certificate', 'software', 'carte'];



  constructor(private router: Router, private formBuilder: FormBuilder, private usersService: UsersService, public functionsService: FunctionsService, private httpService: HttpService, private route: ActivatedRoute) {
    // this.submenu = this.route.snapshot.paramMap.get('submenu');
    // if (!this.submenuList.includes(this.submenu)) {
    //   this.router.navigate(['/not-found']);
    // }
    if (usersService.getUserType() != 'candidat') {
      this.router.navigate(['/not-found']);
    }

    this.candidates = this.usersService.getCurrentUser();

    // this.candidatesProfiles = (this.candidates.getCandidatesProfiles() != null) ? new CandidatesProfiles(this.candidates.getCandidatesProfiles()) : new CandidatesProfiles({});
    this.trainingList = this.functionsService.getTrainingsList();
    this.professionList = this.functionsService.getProfessionsList();



    if (localStorage.getItem('jobIDToApply') && localStorage.getItem('jobIDToApply') != undefined) {
      this.jobIDToApply = localStorage.getItem("jobIDToApply");

      this.showBtnToGoApplyJob = true;
    }
  }



  ngOnInit() {

    // console.log(this.getCandidateTrainings());
    // console.log(this.getCandidateSkills());
    console.log(this.getCandidateCertificats());
    // console.log(this.functionsService.getLanguagesList());
    this.getCandidateLanguages();
    this.initPersonalInfoForm();
    this.langage();
    this.getCandidateProfiles();

    this.initProfileForm();

    this.initExperiencesForm();

    this.initTrainingForm();

    this.getCandidateCertificats();

    this.getCandidateSkills();
    this.initLanguageForm();

    this.initSkillForm();

    this.initCertificatForm();

    this.calculateTotalFillingRate();
  }

  calculateTotalFillingRate() {

    if (this.candidates.getGender() !== null && this.candidates.getGender() !== '') {
      this.personalInfoRate = 20;
    } else {
      this.personalInfoRate = 0;
    }

    if (this.candidatesProfiles.getProfessions() && this.candidatesProfiles.getProfessions().getLibelle() != undefined) {
      this.profileRate = 20;
    } else {
      this.profileRate = 0;
    }

    if (this.candidates.getCandidatesTrainings().length > 0) {
      this.trainingRate = 15;
    } else {
      this.trainingRate = 0;
    }

    if (this.candidates.getCandidatesLanguages().length > 0) {
      this.languageRate = 15;
    } else {
      this.languageRate = 0;
    }

    if (this.candidates.getCandidatesSkills().length > 0) {
      this.skillRate = 15;
    } else {
      this.skillRate = 0;
    }

    if (this.candidates.getCandidatesExperiences().length > 0) {
      this.experienceRate = 15;
    } else {
      this.experienceRate = 0;
    }

    this.totalFillingRate = this.personalInfoRate + this.profileRate + this.experienceRate + this.trainingRate + this.languageRate + this.skillRate;

    localStorage.setItem('totalFillingRate', JSON.stringify(this.totalFillingRate));
  }

  initPersonalInfoForm() {
    this.calculateTotalFillingRate();
    this.loadCountries();

    this.tempWorkerValue = this.candidates.getTempWorker();
    this.driverLicenceValue = this.candidates.getDriverLicence();
    this.passportValue = this.candidates.getPassport();
    this.cvValue = this.candidates.getCvPath();
    this.cvPath = (this.candidates.getCvPath() != null) ? this.candidates.getCvPath() : '';
    this.idcardValue = this.candidates.getIdCard();
    this.idCard = (this.candidates.getIdCard() != null) ? this.candidates.getIdCard() : '';
    this.personalInfoForm = this.formBuilder.group({
      gender: [this.candidates.getGender(), Validators.required],
      firstName: [this.candidates.getFirstName(), Validators.required],
      lastName: [this.candidates.getLastName(), Validators.required],
      email: [this.candidates.getEmail(), [Validators.required, Validators.email]],
      dateBirth: [this.candidates.getDateBirth(), Validators.required],
      phone1: [this.candidates.getPhone1(), Validators.required],
      phone2: [(this.candidates.getPhone2() == null || this.candidates.getPhone2() == 'null') ? '' : this.candidates.getPhone2()],
      maritalStatus: [(this.candidates.getMaritalStatus() == null || this.candidates.getMaritalStatus() == 'null') ? '' : this.candidates.getMaritalStatus()],
      country: [(this.candidates.getCountry() == null || this.candidates.getCountry() == 'null') ? '' : this.candidates.getCountry()],
      city: [(this.candidates.getCity() == null || this.candidates.getCity() == 'null') ? '' : this.candidates.getCity()],
    });
  }

  onSubmitPersonalInfoForm(): any {

    if (this.cvValue == null && this.cvFile == null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Veuillez joindre votre CV.',
      })
      return false;
    }

    if (this.idcardValue == null && this.idcardFile == null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Veuillez joindre votre pièce d\'identité (CNI/Passport)',
      })

      return false;
    }

    let formValue: any = this.personalInfoForm.value;
    formValue['tempWorker'] = this.getRadioChoice('tempWorkerYes', 'tempWorkerNo');
    formValue['driverLicence'] = this.getRadioChoice('driveLicenceYes', 'driveLicenceNo');
    formValue['passport'] = this.getRadioChoice('passportYes', 'passportNo');
    formValue['cvFile'] = this.cvFile;
    formValue['idcard'] = this.idcardFile;

    this.personalInfoIsLoading = true;
    this.httpService.editCandidateData(formValue).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));
          this.personalInfoIsLoading = false;
          this.candidates = this.usersService.getCurrentUser();
          this.initPersonalInfoForm();
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Vos informations personnelles ont été mises à jour.',
          })
        }
      },
      (error) => {
        console.log(error);
        this.personalInfoIsLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }

  initProfileForm() {
    this.calculateTotalFillingRate();
    this.getCandidateProfiles();
    this.professionList = this.functionsService.getProfessionsList();

    // let professions = (this.candidatesProfiles.getProfessions() != undefined) ? new Professions(this.candidatesProfiles.getProfessions()) : new Professions({});
    // let trainings = (this.candidatesProfiles.getTrainings() != undefined) ? new Trainings(this.candidatesProfiles.getTrainings()) : new Trainings({});
    this.profilesForm = this.formBuilder.group({
      profession_id: ['1', Validators.required],
      years_of_experience: ['2 à 5ans', Validators.required],
      position_level: ['Jeune diplomé', Validators.required],
      level_of_study: ['Secondaire', [Validators.required]],
      training_id: ['1', Validators.required],
      availability: ['Immédiate'],
      mobility: ['Régionale'],
      status: ['Sans emploi'],
      current_salary: ['400 à 500K'],
      desired_salary: ['400 à 500K'],
    });

    // if (professions.getId() != undefined && professions.getId() != null) {
    //   this.profileRate = 20;
    // }
  }

  onSubmitProfileForm(): any {
    let formValue: any = this.profilesForm.value;
    this.profileIsLoading = true;
    console.log(formValue);

    this.httpService.updateProfile(formValue, this.candidates.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));
          this.profileIsLoading = false;
          this.initProfileForm();
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Votre profile a été mise à jour.',
          })
          this.candidates = this.usersService.getCurrentUser();
          this.initProfileForm();
          this.getCandidateProfiles();
        }
      },
      (error) => {
        console.log(error);
        this.profileIsLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }

  showHideExperienceFormContent(experienceProValue: any) {

    let experienceFormContent: any = document.getElementById('experienceFormContent');

    if (experienceProValue) {
      experienceFormContent.style.display = "block";
    } else {
      experienceFormContent.style.display = "none";
    }
  }

  initExperiencesForm() {
    this.calculateTotalFillingRate();
    this.getCandidateExperiences();
    this.experienceProValue = this.experienceList.length > 0 ? true : false;
    this.showHideExperienceFormContent(this.experienceProValue);
    this.areaActivityList = this.functionsService.getAreaActivitiesList();
    this.experiencesForm = this.formBuilder.group({
      area_activity_id: ['', Validators.required],
      job_title: ['', Validators.required],
      month_start: ['', Validators.required],
      year_start: ['', Validators.required],
      month_end: [''],
      year_end: [''],
      company: ['', Validators.required],
      position_level: ['', Validators.required],
      team_management: [''],
      supervisor_title: ['', Validators.required],
      reason_for_leaving: [''],
      task_description: ['', Validators.required],
    });
  }

  onSubmitExperienceForm(): any {
    const element: any = document.getElementById('experienceInProgress');
    let in_progress = element.checked;
    let formValue: any = this.experiencesForm.value;
    formValue['in_progress'] = (in_progress) ? 'true' : 'false';
    formValue['period_start'] = formValue.month_start + '-' + formValue.year_start;
    const monthEnd = (formValue.month_end == '') ? this.currentMonth : formValue.month_end;
    const yearEnd = (formValue.year_end == '') ? this.currentYear : formValue.year_end;
    formValue['period_end'] = monthEnd + '-' + yearEnd;
    formValue['certificate'] = this.attestationFile;

    this.experienceIsLoading = true;

    this.httpService.addCandidateExperience(formValue, this.candidates.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));
          this.experienceIsLoading = false;
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Expérience ajoutée.',
          })
          this.candidates = this.usersService.getCurrentUser();
          this.initExperiencesForm();
          this.getCandidateExperiences();
        }
      },
      (error) => {
        this.experienceIsLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }

  removeExperience(id: number) {
    Swal.fire({
      title: 'Souhaitez vous supprimer cette expérience ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeCandidateExperience(id, this.candidates.getToken()).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('currentCandidate', JSON.stringify(data));
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Expérience supprimée.',
              });
              this.candidates = this.usersService.getCurrentUser();
              this.initExperiencesForm();
              this.getCandidateExperiences();
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }

  initTrainingForm() {
    this.calculateTotalFillingRate();
    this.getCandidateTrainings();
    this.trainingsForm = this.formBuilder.group({
      training_id: ['', Validators.required],
      university: ['', Validators.required],
      level_of_study: ['', Validators.required],
      month_start: ['', Validators.required],
      year_start: ['', Validators.required],
      month_end: [''],
      year_end: [''],
    });
  }

  onSubmitTrainingForm(): any {
    // const element: any = document.getElementById('trainingInProgress');
    // let in_progress = element.checked;
    // let formValue: any = this.trainingsForm.value;
    // formValue['in_progress'] = (in_progress) ? 'true' : 'false';
    // formValue['period_start'] = '21-2022';
    // const monthEnd = (formValue.month_end == '') ? this.currentMonth : formValue.month_end;
    // const yearEnd = (formValue.year_end == '') ? this.currentYear : formValue.year_end;
    // formValue['period_end'] = '12-1235';
    // formValue['level_of_study'] = 'Secondaire';
    // formValue['training_id'] = '7';
    // formValue['diploma'] = this.diplomaFile;


    const element: any = document.getElementById('trainingInProgress');
    let in_progress = element.checked;
    let formValue: any = this.trainingsForm.value;
    formValue['in_progress'] = (in_progress) ? 'true' : 'false';
    formValue['period_start'] = formValue.month_start + '-' + formValue.year_start;
    const monthEnd = (formValue.month_end == '') ? this.currentMonth : formValue.month_end;
    const yearEnd = (formValue.year_end == '') ? this.currentYear : formValue.year_end;
    formValue['period_end'] = monthEnd + '-' + yearEnd;
    formValue['diploma'] = this.diplomaFile;

    console.log(formValue);


    this.trainingIsLoading = true;

    this.httpService.addCandidateTraining(formValue, this.candidates.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));
          this.trainingIsLoading = false;
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Formation ajoutée.',
          })
          this.candidates = this.usersService.getCurrentUser();
          this.initTrainingForm();
          this.getCandidateTrainings();
        }
      },
      (error) => {
        console.log(error);
        this.trainingIsLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }

  removeTraining(id: number) {
    Swal.fire({
      title: 'Souhaitez vous supprimer cette formation ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeCandidateTraining(id, this.candidates.getToken()).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('currentCandidate', JSON.stringify(data));
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Formation supprimée.',
              });
              this.candidates = this.usersService.getCurrentUser();
              this.initTrainingForm();
              this.getCandidateTrainings();
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }

  langage() {
    this.languageList = this.functionsService.getLanguagesList();
    return this.languageList;
  }
  candidatLangage() {

    this.getCandidateLanguages();
  }
  initLanguageForm() {
    console.log(1);
    this.calculateTotalFillingRate();

    this.languagesForm = this.formBuilder.group({
      language_id: ['', Validators.required],
      level: ['', Validators.required],
    });
  }

  onSubmitLanguageForm(): any {
    let formValue: any = this.languagesForm.value;

    this.languageIsLoading = true;

    this.httpService.addCandidateLanguage(formValue, this.candidates.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));
          this.languageIsLoading = false;
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Langue ajoutée.',
          })
          this.candidates = this.usersService.getCurrentUser();
          this.initLanguageForm();
          this.getCandidateLanguages();
        }
      },
      (error) => {
        console.log(error);
        this.languageIsLoading = false;
        if (error.error.message == 'CANDIDATE_LANGUAGE_ALREADY_EXIST') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Cette langue a déjà été ajoutée.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      }
    );
  }

  removeLanguage(id: number) {
    Swal.fire({
      title: 'Souhaitez vous supprimer cette langue ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeCandidateLanguage(id, this.candidates.getToken()).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('currentCandidate', JSON.stringify(data));
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Langue supprimée.',
              });
              this.candidates = this.usersService.getCurrentUser();
              this.initLanguageForm();
              this.getCandidateLanguages();
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }

  initSkillForm() {
    this.calculateTotalFillingRate();
    this.getCandidateSkills();
    this.skillList = this.functionsService.getSkillsList();
    this.skillsForm = this.formBuilder.group({
      skill_id: ['', Validators.required],
      level: ['', Validators.required],
    });
  }

  onSubmitSkillForm(): any {
    let formValue: any = this.skillsForm.value;

    this.skillIsLoading = true;

    this.httpService.addCandidateSkill(formValue, this.candidates.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));
          this.skillIsLoading = false;
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Logiciel ajouté.',
          })
          this.candidates = this.usersService.getCurrentUser();
          this.initSkillForm();
          this.getCandidateSkills();
        }
      },
      (error) => {
        this.skillIsLoading = false;
        if (error.error.message == 'CANDIDATE_SKILL_ALREADY_EXIST') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Ce logiciel a déjà été ajouté.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      }
    );
  }

  removeSkill(id: number) {
    Swal.fire({
      title: 'Souhaitez vous supprimer ce logiciel ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeCandidateSkill(id, this.candidates.getToken()).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('currentCandidate', JSON.stringify(data));
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Logiciel supprimé.',
              });
              this.candidates = this.usersService.getCurrentUser();
              this.initSkillForm();
              this.getCandidateSkills();
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }

  initCertificatForm() {
    this.calculateTotalFillingRate();
    this.getCandidateCertificats();
    this.certificatsForm = this.formBuilder.group({
      libelle: ['', Validators.required]
    });
  }

  onSubmitCertificatForm(): any {
    console.log(this.certificatsForm.value);
    let formValue: any = this.certificatsForm.value;
    formValue['certificat'] = this.certificatFile;

    this.certificatIsLoading = true;


    this.httpService.addCandidateCertificat(formValue, this.candidates.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));
          this.certificatIsLoading = false;
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Certificat ajouté.',
          })
          this.initCertificatForm();
          this.candidates = this.usersService.getCurrentUser();
          this.getCandidateCertificats();
        }
      },
      (error) => {
        console.log(error);
        this.certificatIsLoading = false;
        if (error.error.message == 'CANDIDATE_CERTIFICAT_ALREADY_EXIST') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Ce certificat a déjà été ajouté.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      }
    );
  }

  removeCertificat(id: number) {
    Swal.fire({
      title: 'Souhaitez vous supprimer ce certificat ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeCandidateCertificat(id, this.candidates.getToken()).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('currentCandidate', JSON.stringify(data));
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Certificat supprimé.',
              });
              this.initCertificatForm();
              this.candidates = this.usersService.getCurrentUser();
              this.getCandidateCertificats();
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }

  getCandidateCertificats() {
    const candidateCertificats: any = (this.candidates.getCandidatesCertificates() != undefined) ? this.candidates.getCandidatesCertificates() : [];

    this.candidateCertificateList = [];

    candidateCertificats.forEach((element: any) => {
      let candidatesCertificats = new CandidatesCertificates(element);
      this.candidateCertificateList.push(candidatesCertificats);
    });
    this.candidateCertificateList;
  }

  getCandidateSkills() {
    const candidateSkills: any = this.candidates.getCandidatesSkills();

    this.candidateSkillList = [];

    candidateSkills.forEach((element: any) => {
      let candidatesSkills = new CandidatesSkills(element);
      this.candidateSkillList.push(candidatesSkills);
    });
    return this.candidateSkillList;
  }

  getCandidateLanguages() {
    const candidateLanguages: any = this.candidates.getCandidatesLanguages();

    this.candidateLanguageList = [];

    candidateLanguages.forEach((element: any) => {
      let candidatesLanguages = new CandidatesLanguages(element);
      this.candidateLanguageList.push(candidatesLanguages);
    });
    return this.candidateLanguageList;
  }

  getCandidateTrainings() {

    const candidateTraining: any = this.candidates.getCandidatesTrainings();

    this.candidateTrainingList = [];

    candidateTraining.forEach((element: any) => {
      let candidatesTrainings = new CandidatesTrainings(element);
      this.candidateTrainingList.push(candidatesTrainings);
    });
    return this.candidateTrainingList;
  }

  getCandidateProfiles() {

    const candidateProfile: any = this.candidates.getCandidatesProfiles();

    console.log(candidateProfile);

    this.candidateProfileList = [];

    candidateProfile.forEach((element: any) => {
      let candidatesProfiles = new CandidatesProfiles(element);
      this.candidateProfileList.push(candidatesProfiles);
    });
    return this.candidateProfileList;
  }

  getCandidateExperiences() {
    const candidateExperience: any = this.candidates.getCandidatesExperiences();
    // console.log(candidateExperience);
    this.experienceList = [];

    candidateExperience.forEach((element: any) => {
      let candidatesExperiences = new CandidatesExperiences(element);
      this.experienceList.push(candidatesExperiences);
    });
    return this.experienceList;
  }

  loadCountries() {
    this.httpService.getCountries().subscribe(data => {
      this.countryData = data;
      const countries: any = data;
      let countryList: any[] = [];
      countries.find((item: { country: any; }) => {
        const country = item.country
        if (!countryList.includes(country)) {
          countryList.push(country)
        }
      });

      this.countryList = countryList.sort();

      this.cityList = this.functionsService.findCitiesOfCountry(this.candidates.getCountry(), this.countryData);
    })
  }

  onChangeCountry(country: string) {
    this.cityList = this.functionsService.findCitiesOfCountry(country, this.countryData);
  }

  async chooseDiploma() {
    const { value: file } = await Swal.fire({
      title: 'Selectionner le fichier',
      input: 'file',
      inputAttributes: {
        'accept': 'application/pdf',
        'aria-label': 'Fichier selectionné'
      }
    });

    if (file) {
      if (file.type != 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Le fichier doit être de type pdf'
        });
      } else if (file.size > '1100000') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La taille du fichier ne peut excéder 1Mo'
        });
      } else {
        this.diplomaFile = file;
        Swal.fire({
          icon: 'success',
          title: 'Fichier chargé',
          text: 'Chargement du fichier terminé.'
        });
      }
    }
  }

  async chooseAttestation() {
    const { value: file } = await Swal.fire({
      title: 'Selectionner le fichier',
      input: 'file',
      inputAttributes: {
        'accept': 'application/pdf',
        'aria-label': 'Fichier selectionné'
      }
    });

    if (file) {
      if (file.type != 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Le fichier doit être de type pdf'
        });
      } else if (file.size > '1100000') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La taille du fichier ne peut excéder 1Mo'
        });
      } else {
        this.attestationFile = file;
        Swal.fire({
          icon: 'success',
          title: 'Fichier chargé',
          text: 'Chargement du fichier terminé.'
        });
      }
    }
  }

  async chooseCertificat() {
    const { value: file } = await Swal.fire({
      title: 'Selectionner le fichier',
      input: 'file',
      inputAttributes: {
        'accept': 'application/pdf',
        'aria-label': 'Fichier selectionné'
      }
    });

    if (file) {
      if (file.type != 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Le fichier doit être de type pdf'
        });
      } else if (file.size > '1100000') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La taille du fichier ne peut excéder 1Mo'
        });
      } else {
        this.certificatFile = file;
        Swal.fire({
          icon: 'success',
          title: 'Fichier chargé',
          text: 'Chargement du fichier terminé.'
        });
      }
    }
  }

  async chooseNewCV() {
    const { value: file } = await Swal.fire({
      title: 'Selectionner votre CV',
      input: 'file',
      inputAttributes: {
        'accept': 'application/pdf',
        'aria-label': 'Cv selectionné'
      }
    });

    if (file) {
      if (file.type != 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Le fichier doit être de type pdf'
        });
      } else if (file.size > '1100000') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La taille du fichier ne peut excéder 1Mo'
        });
      } else {
        this.cvFile = file;
        Swal.fire({
          icon: 'success',
          title: 'Fichier chargé',
          text: 'Chargement du fichier terminé.'
        });
      }
    }
  }

  async chooseNewIdcard() {
    const { value: file } = await Swal.fire({
      title: 'Selectionner votre carte d\'identité ou passport',
      input: 'file',
      inputAttributes: {
        'accept': 'application/pdf',
        'aria-label': 'CNI/passport selectionné'
      }
    });

    if (file) {
      if (file.type != 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Le fichier doit être de type pdf'
        });
      } else if (file.size > '1100000') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La taille du fichier ne peut excéder 1Mo'
        });
      } else {
        this.idcardFile = file;
        Swal.fire({
          icon: 'success',
          title: 'Fichier chargé',
          text: 'Chargement du fichier terminé.'
        });
      }
    }
  }

  getRadioChoice(idRadioYes: string, idRadioNo: string): any {
    const radioYesElement: any = document.getElementById(idRadioYes);
    const radioNoElement: any = document.getElementById(idRadioNo);

    if (radioYesElement.checked) {

      return true;
    }
    if (radioNoElement.checked)
      return false;

    if (radioYesElement.checked == false && radioNoElement.checked == false)
      return false;
  }

  submit() {
    this.step = this.step + 1;
  }

  previous() {
    this.step = this.step - 1;
  }
}
